import { Rights } from "../../rights";

export class responseGetUser {
    email: string;
    name: string;
    rights: Rights;
    username: string;
    constructor(data) {
        this.email = data.email;
        this.name = data.name;
        this.rights = new Rights(data.rights);
        this.username = data.username;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-user.ts